export default {
  getMemberFeed: 'member/GET_MEMBER_FEED',
  getMemberFeedSuccess: 'member/GET_MEMBER_FEED_SUCCESS',
  getMemberFeedFailure: 'member/GET_MEMBER_FEED_FAILURE',

  getMembersForSearchField: 'member/GET_MEMBERS_FOR_SEARCH_FIELD',
  getMembersForSearchFieldSuccess: 'member/GET_MEMBERS_FOR_SEARCH_FIELD_SUCCESS',
  getMembersForSearchFieldFailure: 'member/GET_MEMBERS_FOR_SEARCH_FIELD_FAILURE',
};
